import { createFileRoute } from '@tanstack/react-router';

import { PageHeader } from '@/components/ui.tsx';
import { MentionsView } from '@/views/feed/mentions-view.tsx';

// ADR-017: @mention timeline across all courses.
export const Route = createFileRoute('/_learner/mentions')({
  component: MentionsPage,
});

function MentionsPage() {
  return (
    <div className="mx-auto max-w-6xl px-6 py-10">
      <PageHeader title="Mentions" subtitle="Posts and comments where someone @-mentioned you." />
      <div className="mt-8">
        <MentionsView />
      </div>
    </div>
  );
}
